<template>
<div  id="app">
<b-modal id="modal-sm" size="md" title="Unlock Account" v-model="showResultModal" no-close-on-esc no-close-on-backdrop hide-header-close>
    <div slot="default">
        <div class='alert alert-warning' role='alert' v-if=!succeeded> {{Msg}} <br> Please Contact System Administrator. </div>
        <div class="alert alert-success" role="alert" v-if=succeeded> {{Msg}} </div>
    </div> 
    <div slot="modal-footer" class="w-100">
        <p class="float-left" variant="primary"></p>
        <b-button variant="primary"  size="md"  class="float-right"  @click="UnlockExit"> Close </b-button>
    </div>
</b-modal>
    <b-modal modal-class="pwd-modal"  id="modal-1"   v-model="showModal" no-close-on-esc no-close-on-backdrop hide-header-close
    ok-variant cancel-variant hide-footer header-class="PopUpHeader" 
      :body-bg-variant=PopUpVar.bodyBgVariant
      :body-text-variant=PopUpVar.bodyTextVariant
      :footer-bg-variant=PopUpVar.footerBgVariant
      :footer-text-variant=PopUpVar.footerTextVariant  @hidden="loadTable()" >
     <UpdatePassword v-if="showModal==true" :UpdatePasswordUser ="updateUser" :showExit ="showExit" :ReturnURL = "returnUrl"></UpdatePassword>
     <template slot="modal-header" > 
        <div>
        <small class="PopUpTitle w-100 text-left">Update User Password</small>
      </div> 
      <div><small class="PopUpTitle w-100 text-right">User ID: {{updateUser}}</small></div>
    </template> 
  </b-modal> 

  <Subtitle  v-bind:ServiceID="this.AppServiceID">
    <template v-slot:header>
    <i class="fas fa-lock"></i><b>  Manage User Password:</b>
    </template> 
  </Subtitle>      
  <Card>
    <CardBody>
    <p>Manage User Password is an Administration action. Any change in this section will affect the web application and its access level. All transactions are monitored, logged and reviewed.
    </p>
    </CardBody>
  </Card> 
   <v-client-table :columns="columns" :data="tableData" :options="options">
     <template slot="status" slot-scope="props">
       <span>{{ props.row.status }}</span>
     </template>
     <span class="pointer" v-on:click="UnlockUser(props.row.username)" v-if="props.row.locked" slot="locked" slot-scope="props">
       <u><i class="fas fa-user-lock"></i></u></span>        
     <span  class="pointer" v-on:click="EditUserPopup(props.row)" slot="edit"  slot-scope="props" ><i class="fas fa-key"></i></span>
    </v-client-table> 
</div>
</template>


<script>
import {mapGetters} from 'vuex'
import axios from 'axios'
import Vue from 'vue';
import moment from 'moment'
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
import Modal from '@/Common/ModelPop.vue';
import UpdatePassword from '@/components/DPEBB/Administrator/PasswordModel.vue';
import { PopUpVariant } from '@/Common/Default/PopUpVariant';
import Subtitle from '@/Common/Default/SubTitle.vue'; 
export default {
  methods: {
    loadTable(){
        var vm = this;
         axios.get('SaskHealthApi/security/GetManagePwdUsers?_='+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token }})
         .then(function (response) {
               vm.tableData=response.data; 
            })
            .catch(function (er) {
                console.log(er)
            }); 
    },
    UnlockExit(){
      this.showResultModal = false;
    },
             UnlockUser(username) {
        this.boxTwo = ''
        this.$bvModal.msgBoxConfirm("Unlock Acount: " + username, {
          title: 'Please Confirm',
          size: 'md',
          buttonSize: 'md',
          okVariant: 'danger',
          cancelVariant: 'default',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: true,
          centered: true, 
          
        })
          .then(value => {
            this.boxTwo = value
            if(value)
            {
              
            var vm = this;
            var url = "SaskHealthApi/Security/PostUnlockUser/"
     var params = {
                "username": username
                } 
        //  params.append("bulletinId", vm.id);
         //axios.post(url, { headers: { 'Authorization': 'Bearer ' + localStorage.access_token },params})
         
        axios({
            method: 'post',
            url: url,
            headers: { 'Authorization': 'Bearer ' + vm.$store.getters.GetAccessToken }, params
            })
            .then(function (response) {
                    console.log(response)
                     vm.succeeded = true;
                    vm.Msg= 'User Account ' + username + ' is successfully unlocked.';
                     vm.showResultModal = true;
                    vm.loadTable();
                    // console.log(vm.Msg);
                
                })
                .catch(function (er) {
                    console.log(er)
                    vm.succeeded = false;
                    vm.Msg= 'User Account ' + username + ' is not successfully unlocked.';
                    console.log(vm.Msg)
                    vm.showResultModal = true;
                });
            }
          })
          .catch(err => {
              console.log(err);
          })
      },
         EditUserPopup(Rowdata){
            this.UserData= Rowdata;
            console.log("dispatch - row " + this.UserData.username);
            // this.$store.dispatch('SetUpdatePasswordUser',"test");
            // this.$store.dispatch('SetShowPasswordExit',true);
            this.updateUser = this.UserData.username; 
            console.log(this.updateUser ) 
            this.showModal = true;
        },
        GoBack(){
            this.$router.push('/DPEBB/MainHome')
        },
        closeModal() {
        this.isModalVisible = false;
      }
    },
     computed:{
          UserName(){
            return !this.$store.getters.GetCurrentUser ? false : this.$store.getters.GetCurrentUser;
        }, 
          AllAppLevel(){
            return this.$store.getters.GetAllApplevel;
          },
    },
  components: {

        Modal:Modal,
        UpdatePassword:UpdatePassword,
          Card,
          CardBody,
          TileNote,
          Subtitle
    },
  data: function () {
    return {
        updateUser:'',
        showExit:true,
        returnUrl:'',
        AppServiceID :6,
        UserData:'',
        isModalVisible: false,
        showModal: false,
        showResultModal:false,
        PopUpVar:PopUpVariant,
        succeeded:false,
        Msg:'',
        columns: ['status','edit' ,'locked', 'username', 'userfullname','role','servicetype','clinicno','clinicname','address','businessphoneno','effectivedate','expirydate','createdby','createddate','lastmodifiedby','modifieddate'],
        tableData: [],//getData(),
        options: {
        texts:{
              count:"Showing {from} to {to} of {count} records|{count} records|One record",
              first:'First',
              last:'Last',
              filter:"Search User Data:",
              filterPlaceholder:"Search in table",
              limit:"Records:",
              page:"Page:",
              noResults:"No matching records",
              filterBy:"Filter by {column}",
              loading:'Loading...',
              defaultOption:'Select {column}',
              columns:'Columns'
          },
          responseAdapter({data}) {
            // const formatData = data.map(o => {
            //     const dataCopy = JSON.parse(JSON.stringify(o))
            //     dataCopy.expirydate = moment(o.expirydate).format('MMMM Do YYYY')
            //     return dataCopy
            //   })
              return {
                data: formatData,
                count: data.length
              };
              // return {
              //   data,
              //   count: data.length
              // }
            },
         // skin:'table table-hover',
          perPage:10,
          perPageValues:[10,15,25],
          dateColumns:['expirydate','effectivedate'],
          templates: {
            expirydate(h, row) {
             // moment.locale('es');               
              return moment(row.expirydate,"YYYY-MM-DD").format('YYYY/MM/DD');  
            },
             effectivedate(h, row) {
             // moment.locale('es');               
              return moment(row.effectivedate,"YYYY-MM-DD").format('YYYY/MM/DD');  
            },
            createddate(h, row) {          
              return moment(row.createddate,"YYYY-MM-DD").format('YYYY/MM/DD');  
            },
            modifieddate(h, row) {          
              return moment(row.modifieddate,"YYYY-MM-DD").format('YYYY/MM/DD');  
            },
          },
          headings: {
            edit: 'Edit',
            username: 'User ID',
            userfullname: 'User Name',
            role:  'Role',
            status: 'Status',
            servicetype: 'Service Type',
            clinicno:    'Clinic Number',
            clinicname:   'Clinic Name',
            address: 'Address',
            businessphoneno: 'Phone',
            effectivedate: 'Effective Date',
            expirydate: 'Expiry Date',
            createdby: 'Created By',
            createddate: 'Created Date',
            lastmodifiedby: 'Last Modified By',
            modifieddate: 'Last Modified Date'
  
          },
          pagination: {
            edge: true,
            nav: 'scroll',
            chunk: 5
          },
          sortable: ['status','locked',  'username', 'userfullname','role','servicetype','clinicno','clinicname','address','businessphoneno','effectivedate','expirydate','createdby','createddate','lastmodifiedby','modifieddate'],
          filterable: ['status','locked','username','userfullname','role','servicetype','clinicno','clinicname','address','businessphoneno','effectivedate','expirydate'],
          //filterable: ['status','username','locked',  'userfullname','role','servicetype','clinicno','clinicname','address','businessphoneno','effectivedate','expirydate','createdby','createddate','lastmodifiedby','modifieddate'],
          sortIcon: {
                  base : 'fas',
                  is: 'fa-sort',
                  up: 'fa-sort-up',
                  down: 'fa-sort-down'
                  },
          }
    }
  },

  created () {
    this.loadTable();

    },
}

</script>
<style >



.pwd-modal .modal {
    padding: 0 !important;
    padding-left: 0px !important;
    overflow-y: scroll;
}

.pwd-modal .modal-dialog { 
    max-width: 800px;
    height: 280px;
    margin: 0;
    top: 10%;
    bottom: 0;
    left: 30%;
    right: 50%;
    display: flex;
    z-index: 100000;
    padding-right: 0px !important;
    padding-left: 0px !important;
}

.modal-open {
    padding: 0 !important;
    padding-left: 0 !important;
    overflow-y: scroll;
}

#modal-1 {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

/* @media (min-width: 992px) {
  .modal .modal-mlg {
    max-width: 90% !important;
    width: 90% !important;;
  }
} */
</style>
